import * as Yup from 'yup'

export const ValidationSchema = Yup.object().shape({
  name: Yup.string().required("Campo requerido"),
  description: Yup.string().nullable(),
  footer: Yup.string().nullable(),
  icon: Yup.string().nullable(),
  image: Yup.mixed().when('showImage', {
    is: true,
    then: Yup.mixed()
      .test("type", "Solo imagenes", (value) => {
        console.log("Validation image", value)
        if (value === "" || value === null || value === undefined) {
          console.log("Validation image 1", value)
          return true
        }
        var regex = /^\w{8}-\w{4}-\w{4}-\w{4}-\w{12}$/;
        if (regex.test(value)) {
          return true
        }
        return Array.isArray(value) && value.length > 0 && value[0].type.includes("image")

      }),
    otherwise: Yup.mixed().nullable()
  }),
  imageActive: Yup.mixed().when('showImage', {
    is: true,
    then: Yup.mixed()
      .test("type", "Solo imagenes", (value) => {
        console.log("Validation imageActive", value)
        if (value === "" || value === null || value === undefined) {
          console.log("Validation imageActive 1", value)
          return true
        }
        var regex = /^\w{8}-\w{4}-\w{4}-\w{4}-\w{12}$/;
        if (regex.test(value)) {
          return true
        }
        return Array.isArray(value) && value.length > 0 && value[0].type.includes("image")

      }),
    otherwise: Yup.mixed().nullable()
  }),
  headerImage: Yup.mixed().when('showHeaderImage', {
    is: true,
    then: Yup.mixed()
      .test("type", "Solo imagenes", (value) => {
        console.log("Validation headerImage", value)
        if (value === "" || value === null || value === undefined) {
          console.log("Validation headerImage 1", value)
          return true
        }
        var regex = /^\w{8}-\w{4}-\w{4}-\w{4}-\w{12}$/;
        if (regex.test(value)) {
          return true
        }
        return Array.isArray(value) && value.length > 0 && value[0].type.includes("image")

      }),
    otherwise: Yup.mixed().nullable()
  }),
  /* image: Yup.string().when('showImage', {
    is: true,
    then: Yup.string().required("Campo requerido"),
    otherwise: Yup.string().nullable()
  }),
  imageActive: Yup.string().when('showImage', {
    is: true,
    then: Yup.string().required("Campo requerido"),
    otherwise: Yup.string().nullable()
  }),
  headerImage: Yup.string().when('showHeaderImage', {
    is: true,
    then: Yup.string().required("Campo requerido"),
    otherwise: Yup.string().nullable()
  }), */
  video: Yup.string().when('showVideo', {
    is: true,
    then: Yup.string().required("Campo requerido"),
    otherwise: Yup.string().nullable()
  }),
  comment: Yup.string().nullable(),
  showImage: Yup.boolean().nullable(),
  showHeaderImage: Yup.boolean().nullable(),
  showVideo: Yup.boolean().nullable(),
  menu: Yup.string().required("Campo requerido"),
  active: Yup.boolean().required("Campo requerido"),
})